var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCredentialBadge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 179,
    height: 180,
    viewBox: "0 0 179 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_99_1296",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 179,
    height: 180
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0771484,
    y: 0.577148,
    width: 178.846,
    height: 178.846,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_99_1296)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.3164 158.787L54.8774 137.807L31.2033 132.705L33.5248 108.286L17.5605 90L33.5248 71.7141L31.2033 47.2948L54.8774 42.193L67.3164 21.2131L89.5001 30.5854L111.684 21.2131L124.123 42.193L147.797 47.2948L145.475 71.7141L161.44 90L145.475 108.286L147.797 132.705L124.123 137.807L111.684 158.787L89.5001 149.415L67.3164 158.787ZM70.4978 149.243L89.5001 141.332L108.589 149.243L119.308 131.358L139.8 126.801L137.937 105.649L151.724 90L137.937 74.2649L139.8 53.1131L119.308 48.6419L108.502 30.7574L89.5001 38.6679L70.4117 30.7574L59.6925 48.6419L39.1998 53.1131L41.0627 74.2649L27.2767 90L41.0627 105.649L39.1998 126.887L59.6925 131.358L70.4978 149.243ZM81.6756 111.295L118.62 74.351L113.346 68.9914L81.6756 100.662L65.654 84.7263L60.3803 90L81.6756 111.295Z",
    fill: "#303468"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.62 74.3513L81.6757 111.296L60.3804 90.0003L65.6541 84.7266L81.6757 100.662L113.346 68.9917L118.62 74.3513Z",
    fill: "#476DFE"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCredentialBadge);
export default __webpack_public_path__ + "static/media/credential_badge.81bcb8a15aa0990edcbfb7951227e5f9.svg";
export { ForwardRef as ReactComponent };